/** @jsxImportSource @emotion/react */
import React from "react";
import { useTranslation } from "react-i18next";
import { shadeColor } from "styles/colors";
import { ReportTabType } from "pages/reports/bi-dashboard-next/models/ReportTabType";

interface ReportsTabsProps {
  activeTab: ReportTabType;
  onTabChange: (tab: ReportTabType) => void;
}

export const ReportsTabs: React.FC<ReportsTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { t } = useTranslation("reports");

  return (
    <div
      css={{
        margin: "0px 0px 0 10px",
        background: "transparent",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        position: "relative",
      }}
    >
      <div
        css={{
          background:
            activeTab === ReportTabType.PUBLIC ? "#2d2d2d" : "transparent",
          color: activeTab === ReportTabType.PUBLIC ? "#fff" : "#2d2d2d",
          padding: "8px 32px 8px 32px",
          borderRadius: 4,
          fontWeight: 600,
          fontSize: 20,
          marginRight: 8,
          position: "relative",
          cursor: "pointer",
          border: "1px solid #2d2d2d",
          ":hover":
            activeTab !== ReportTabType.PUBLIC
              ? {
                  background: shadeColor("#2d2d2d", 0.25),
                  color: "#fff",
                }
              : {},
        }}
        onClick={() => onTabChange(ReportTabType.PUBLIC)}
      >
        {t("Organization Reports")}
      </div>
      <div
        css={{
          background:
            activeTab === ReportTabType.MY ? "#2d2d2d" : "transparent",
          color: activeTab === ReportTabType.MY ? "#fff" : "#2d2d2d",
          padding: "8px 32px 8px 32px",
          borderRadius: 4,
          fontWeight: 600,
          fontSize: 20,
          position: "relative",
          cursor: "pointer",
          border: "1px solid #2d2d2d",
          ":hover":
            activeTab !== ReportTabType.MY
              ? {
                  background: shadeColor("#2d2d2d", 0.25),
                  color: "#fff",
                }
              : {},
        }}
        onClick={() => onTabChange(ReportTabType.MY)}
      >
        {t("My Reports")}
      </div>
    </div>
  );
};
